import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";

import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Grid from "@mui/material/Grid";

import { GlobalStyle } from "@/themes";
import {
    AuthContainer,
    AuthSection,
    Heading,
    SubHeading,
} from "@/auth/StyledComponents";
import { PageTitle } from "@/common/CommonComponents";
import Payment from "@/payment/Payment";
import AuthNav from "@/auth/AuthNav";

export default function PaymentRequired() {
    const theme = useTheme();
    const [searchParams] = useSearchParams();
    const priceKey = searchParams.get("priceKey") || "";

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <AuthContainer isMobile={isMobile}>
            <Helmet>
                <PageTitle title="Payment Details" />
            </Helmet>
            <GlobalStyle theme={theme.palette.mode} />
            <AuthNav internalLinkLabel="Sign Up" internalLinkUrl="/sign-up" />

            <AuthSection isMobile={isMobile}>
                <Grid container direction="column" spacing={5}>
                    <Grid item container direction="column" spacing={2}>
                        <Grid item>
                            <Heading>Enter Payment Details</Heading>
                        </Grid>
                        <Grid item>
                            <SubHeading>Not satisfied?</SubHeading>
                        </Grid>
                        <Grid item>
                            <SubHeading>
                                Cancel within 30 days for a full refund.
                            </SubHeading>
                        </Grid>
                    </Grid>

                    <Grid item>
                        <Payment confirmText="Subscribe" priceKey={priceKey} />
                    </Grid>
                </Grid>
            </AuthSection>
        </AuthContainer>
    );
}
